import { useState } from "react";
import CheckmarkIcon from "../icons/content-pages/CheckmarkIcon";
import PartnerForm from "./PartnerForm";
import "./PartnersPage.scss";
import PartnerFormSuccess from "./PartnerFormSuccess";

export default function PartnersPage() {
  const [submitted, setSubmitted] = useState(false);

  function scrollTo(id: string, offset = 45) {
    var element = document.getElementById(id) as HTMLElement;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  function onFormSubmitted() {
    setSubmitted(true);
    setTimeout(() => {
      scrollTo('formSubmitted');
    }, 50);
  }

  return (
    <main className="partners-content">
      <section className={"one"}>
        <div className="content">
          <div className="flex">
            <div className="text">
              <h1>Innovation Served:<br />We partner with the best.</h1>
              <p>Our integrations bring you menu data sync, cross-channel management, seamless display, and more.</p>
              <div className="button-set">
                <div onClick={() => scrollTo('ourPartners')} className={"ant-btn ant-btn-lg"}>Find a Partner</div>
                <div onClick={() => scrollTo('becomePartner')} className={"ant-btn ant-btn-primary ant-btn-lg"}>Become a Partner</div>
              </div>
            </div>
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/content/partners/PartnerHero2.webp" alt="Partner Hero" />
            </div>
          </div>
        </div>
      </section>

      <section className="two gray-bg" id="ourPartners">
        <div className="content">
          <h1>Our Featured Partners</h1>

          <h2>Cloud-Based POS</h2>
          <div className="flex">
            <div className="partner-tile">
              <a href="/feature/why-is-toast-pos-better.html">
                <div className="tag integration">Integration</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/ToastWordmark.svg" alt="Toast" />
                </div>
                <p>Quick to learn, and even easier to use: Toast's restaurant-first platform is built with you in mind.</p>
              </a>
            </div>
            <div className="partner-tile">
              <a href="/feature/square-pos.html">
                <div className="tag integration">Integration</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/SquareWordmark.svg" alt="Square" />
                </div>
              </a>
              <p>Square is a versatile point-of-sale system that simplifies transactions, streamlines operations, and enhances customer experiences for food service establishments.</p>
            </div>
            <div className="partner-tile">
              <a href="/feature/treez-pos.html">
                <div className="tag integration">Integration</div>
                <div className="img-container">
                  <img style={{maxWidth: '150px'}} src="https://timber.mhmcdn.com/site/feature/treez/TreezLogo.png" alt="Treez" />
                </div>
              </a>
              <p>Engineered to grow your dispensary. Treez offers everything you need to increase sales, streamline operations, simplify compliance, and provide better customer experiences.</p>
            </div>
          </div>

          <h2>Website</h2>
          <div className="flex">
            <div className="partner-tile">
              <a href="/content/partner/bentobox">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/BentoboxWordmark.svg" alt="BentoBox" />
                </div>
              </a>
              <p>BentoBox helps restaurants create better online experiences for their customers and their staff with a full suite of digital tools.</p>
            </div>
            <div className="partner-tile">
              <a href="/content/partner/popmenu">
                <div className="tag integration">Integration</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/PopmenuWordmark.svg" alt="PopMenu" />
                </div>
              </a>
              <p>Meet the marketing technology platform designed to make growing your restaurant easy.</p>
            </div>
          </div>

          <h2>Digital Display</h2>
          <div className="try-display-banner">
            <div className="left-banner">
              <div className="try">Try MustHaveMenus</div>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/DSARed.svg" alt="dislay"/>
              <div className="display">Display</div>
              <div className="sep"/>
              <div className="manage">Manage all of your digital displays!</div>
            </div>
            <a href="/feature/digital-menu-board-solution.html" target="_blank" rel="noreferrer">Learn More</a>
          </div>
          <div className="flex">
            <div className="partner-tile">
              <a href="/content/partner/optisigns">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/OptisignsWordmark.svg" alt="OptiSigns" />
                </div>
              </a>
              <p>Elevate your restaurant experience with simple and affordable digital signage.</p>
            </div>
            <div className="partner-tile">
              <a href="/content/partner/telemetry">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/TelemetryWordmark.png" alt="TelemetryTV" />
                </div>
              </a>
              <p>Enhance the guest experience with TelemetryTV's captivating visuals</p>
            </div>
          </div>

          <h2>Online Ordering</h2>
          <div className="flex">
            <div className="partner-tile">
              <a href="/content/partner/mryum">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/MrYumLogo.svg" alt="Mr Yum" />
                </div>
              </a>
              <p>Mr Yum provides restaurants with a user-friendly mobile menu and ordering platform, enabling customers to browse menus, place orders, and make payments easily through their smartphones.</p>
            </div>
          </div>
          <h2>Back Office</h2>
          <div className="flex">
            <div className="partner-tile">
              <a href="/content/partner/schedulefly">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/ScheduleFlyWordmark.png" alt="ScheduleFly" />
                </div>
              </a>
              <p>Used by thousands of successful independent franchise restaurants to improve staff operations.</p>
            </div>
            <div className="partner-tile">
              <a href="/content/partner/restaurant365">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img src="https://timber.mhmcdn.com/site/content/partners/Restaurant365Wordmark.svg" alt="Restaurant 365" />
                </div>
              </a>
              <p>Restaurant 365 is a comprehensive restaurant management software that streamlines operations, simplifies accounting, and provides real-time insights, empowering restaurants to efficiently manage their business and drive growth.</p>
            </div>
          </div>
          <h2>Food Service</h2> 
          <div className="flex">
            <div className="partner-tile">
              <a href="/content/partner/shamrock">
                <div className="tag affiliate">Affiliate</div>
                <div className="img-container">
                  <img style={{width: '130px', marginTop: '-15px'}} src="https://timber.mhmcdn.com/site/content/partners/ShamrockWordmark.jpeg" alt="Shamrock Foods" />
                </div>
              </a>
              <p>Shamrock Food Service is a leading food distribution company dedicated to providing high-quality products and comprehensive solutions to restaurants, healthcare facilities, educational institutions, and other foodservice establishments.</p>
            </div>
          </div>
          <div className="text-center">
            <div onClick={() => scrollTo('becomePartner')} className={"ant-btn ant-btn-primary ant-btn-lg"}>Become a Partner</div>
          </div>
        </div>
      </section>

      <section className="three" id="becomePartner">
        {!submitted && <div className="content">
          <div className="why-partner">
            <h1>Partner with us!</h1>
            <ul>
              <li><CheckmarkIcon fill="#e42436" /><span>Expand your customer base and interact with over 100,000 monthly site visitors</span></li>
              <li><CheckmarkIcon fill="#e42436" /><span>Increase your brand awareness</span></li>
              <li><CheckmarkIcon fill="#e42436" /><span>Improve your customer experience</span></li>
              <li><CheckmarkIcon fill="#e42436" /><span>Grow your business</span></li>
            </ul>
          </div>

          <h2>Complete the form to submit a partnership request</h2>
          <PartnerForm setSubmitted={onFormSubmitted} formWidth={830} />
        </div>}
        {submitted && <div className="content" id="formSubmitted">
          <PartnerFormSuccess />
        </div>}
      </section>
    </main>
  )
}
